export default [
  {
    path: '/canteenIndex',
    name: 'canteenIndex',
    meta: { title: '食堂质量测评问卷调查' },
    component: () => import('../views/canteen/index')
  },
  {
    path: '/canteenAdd',
    name: 'canteenAdd',
    meta: { title: '食堂质量测评问卷调查' },
    component: () => import('../views/canteen/add')
  },
  {
    path: '/proposalIndex',
    name: 'proposalIndex',
    meta: { title: '2027年瑞安市民生实事建议项目征集' },
    component: () => import('../views/proposal/index')
  },
  /*{
    path: '/msxcIndex',
    name: 'msxcIndex',
    meta: { title: '码上巡察' },
    component: () => import('../views/msxc/closeTips')
  },*/
  {
    path: '/msxcIndex',
    name: 'msxcIndex',
    meta: { title: '码上巡察' },
    component: () => import('../views/msxc/index')
  },
  {
    path: '/msxcForm',
    name: 'msxcForm',
    meta: { title: '码上巡察' },
    component: () => import('../views/msxc/form')
  },
  {
    path: '/act/raxw/login',
    name: 'actRaxwLogin',
    meta: { title: '瑞安新闻登录' },
    component: () => import('../views/act/raxwLogin')
  },
  {
    path: '/act/zlb/login',
    name: 'actZlbLogin',
    meta: { title: '浙里办登录' },
    component: () => import('../views/act/zlbLogin')
  },
  {
    path: '/act/weichatLogin',
    name: 'actWeichatLogin',
    meta: { title: '微信登录' },
    component: () => import('../views/act/weichatLogin')
  },
  {
    path: '/act/yfns/index',
    name: 'actYfnsIndex',
    meta: { title: '防溺水公益宣传线上有奖竞答' },
    component: () => import('../views/act/yfns/index')
  },
  {
    path: '/act/yfns/dt',
    name: 'actYfnsDt',
    meta: { title: '防溺水公益宣传线上有奖竞答' },
    component: () => import('../views/act/yfns/dt')
  },
  {
    path: '/act/yfns/cj',
    name: 'actYfnsCj',
    meta: { title: '防溺水公益宣传线上有奖竞答' },
    component: () => import('../views/act/yfns/cj')
  },
  {
    path: '/act/yfns/jg',
    name: 'actYfnsJg',
    meta: { title: '防溺水公益宣传线上有奖竞答' },
    component: () => import('../views/act/yfns/jg')
  },
  {
    path: '/supplierIndex',
    name: 'supplierIndex',
    meta: { title: '供应商查询', keepAlive: true },
    component: () => import('../views/supplier/index')
  },
  {
    path: '/supplierDetail',
    name: 'supplierDetail',
    meta: { title: '供应商详情' },
    component: () => import('../views/supplier/detail')
  },
  {
    path: '/supplierPcIndex',
    name: 'supplierPcIndex',
    meta: { title: '供应商查询', keepAlive: true },
    component: () => import('../views/supplier/pc/index')
  },
  {
    path: '/supplierPcDetail',
    name: 'supplierPcDetail',
    meta: { title: '供应商详情' },
    component: () => import('../views/supplier/pc/detail')
  },
  //清廉六问码上监督
  {
    path: '/msjdCover',
    name: 'msjdCover',
    meta: { title: '作风效能清风六问' },
    component: () => import('../views/msjd/cover') //封面页
  },
  {
    path: '/msjdIndex',
    name: 'msjdIndex',
    meta: { title: '作风效能清风六问' },
    component: () => import('../views/msjd/index') //我要监督首页
  },
  {
    path: '/msjdForm',
    name: 'msjdForm',
    meta: { title: '作风效能清风六问' },
    component: () => import('../views/msjd/form') //我要监督表单页
  },
  {
    path: '/msjdFormDz',
    name: 'msjdFormDz',
    meta: { title: '作风效能清风六问' },
    component: () => import('../views/msjd/formDz') //我要点赞表单页
  }
];
